import { createContext, useContext } from "react";
import { AnalyticsEvent, AnalyticsIdentity, AnalyticsPageView } from "@/analytics/types";
import { EventTrackerTrackResult } from "@/analytics/EventTracker";

export interface AnalyticsContextType {
    identity: AnalyticsIdentity | undefined;
    currentPage: { name: AnalyticsPageView | undefined; path: string | undefined };
    setCurrentPage: (page: {
        name: AnalyticsPageView | undefined;
        path: string | undefined;
    }) => void;
    track: ({
        event,
        data
    }: {
        event: AnalyticsEvent;
        data?: Record<string, any>;
    }) => EventTrackerTrackResult;
    identify: () => EventTrackerTrackResult;
    page: () => EventTrackerTrackResult;
}

export const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);

export function useAnalytics() {
    const context = useContext(AnalyticsContext);
    if (!context) {
        throw new Error("useAnalytics must be used within an AnalyticsProvider");
    }
    return context;
}
